import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalsService } from 'app/services/globals.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { OrdersService } from 'app/services/orders.service';
import { UsersService } from 'app/services/users.service';
import { isNullOrUndef } from 'chart.js/helpers';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { PrintService } from '../../services/print.service'

@Component({
	selector: 'app-order-entry-log',
	templateUrl: './order-entry-log.component.html',
	styleUrls: ['./order-entry-log.component.scss'],
	providers: [
		// Scoped to this component only: summit uses en-GB ordering (DD/MM/YYYY) for the transaction date range picker.
		{
			provide: DateAdapter,
			useFactory: (platform: Platform, globalsService: GlobalsService) => {
				const client = globalsService.getApiConfig()?.env?.client;
				return new NativeDateAdapter(client === 'summit' ? 'en-GB' : 'en-US', platform);
			},
			deps: [Platform, GlobalsService]
		},
		{ provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }
	]
})
export class OrderEntryLogComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	config: any = false;
	user: any = false;

	userlocations: any = false;
	defaultlocation: any = false;
	issalesman: any = false;
	posuser: any = false;
	displaydetails: any = false;

	limits: any = false;

	start_d: any = false;
	end_d: any = false;
	fetching: any;

	exportingpdf:any = false;
	exportingxls:any = false;

	datasource: MatTableDataSource<any>;
	filteredData: any = false;
	unfilteredData: any = false;

	subscripts: any = [];

	salespeople: any = false;
	locations: any = false;
	allusers: any = false;

	sources:any = [];
	totalsArray: any = [];

	orderdetails: any = false;
	panelOpenState: any = false;
	subtitle: any = false;

	displayedColumns: string[] = [
		'source',
		'debtorno',
		'orderno',
		'orderstatus',
		'orddate',
		'transno',
		'trandate',
		'units',
		'total',
		'location',
		'payterms',
		'comments',
		'enteredby',
		'salesmancode',
		'salesmanname',
	];

	searchbar = new UntypedFormControl('');
	selected_salespeople = new UntypedFormControl(['any']);
	selected_sources = new UntypedFormControl('');
	selected_locations = new UntypedFormControl('');
	fromdateCtrl = new UntypedFormControl('')
	todateCtrl = new UntypedFormControl('')
	todate = new Date();
	fromdate = new Date();

	
	orders_total: any = 0;
	orders_total_count: any = 0;

	orders_backoffice: any = {count: 0, total: 0};
	orders_pos: any = {count: 0, total: 0};
	orders_web: any = {count: 0, total: 0};
	orders_salesperson: any = {count: 0, total: 0};
	showtotals: Boolean = false;

	private datePipe = new DatePipe('en-US');

	constructor(private userService: UsersService, private printService: PrintService, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService, private ordersService: OrdersService ) {
		this.config = this.globalsService.getApiConfig();

		
	}

	@ViewChild(MatSort) set matSort(ms: MatSort) {
		if (ms) {
		  this.sort = ms;
		  if (this.datasource) this.datasource.sort = ms;
		}
	  }
	

	copyToClipboard(item){}

	viewInvoicedOrder(orderno: any, content: any) {
		this.ordersService.getInvoicedOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order

			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {});
		});
	}

	openDocument(transaction: any, content: any, display: string) {
		switch (transaction.type) {
		case '11':
			this.globalsService.getCreditNote(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => { }, (reason) => { });
			})
			break;
		case '10':
			this.globalsService.getInvoice(transaction.id, display).subscribe((result: any) => {
				this.displaydetails = result;
				this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => { }, (reason) => { });
			})
			break;
		}
	}


	ngOnInit(): void {
		forkJoin({
			user: this.globalSearchService.user.pipe(take(1)),
			locations: this.globalsService.getUserLocations().pipe(take(1)),
			salespeople: this.globalsService.getSalesPeople().pipe(take(1)),
			isPOS: this.usersService.isPosUser().pipe(take(1)),
			order_source: this.globalsService.getOrderSources().pipe(take(1)),
			all_users: this.userService.getUsers().pipe(take(1))
		}).subscribe(({ user, locations, salespeople, isPOS, order_source, all_users}) => {
			this.user = user.user;
			this.allusers = [{userid:'', realname:'Empty'},...all_users as []];
			this.userlocations = locations;
			this.locations = locations;
			this.salespeople = salespeople;
			this.posuser = isPOS ? true : false;
			this.sources = (order_source as []).map((s: any)=>{return {view: s.name, value: s.placedfromid}});
			this.set_salesman_pos_location_limits();
			this.setDefaultTransactionDates();
			this.loadorderdata();
		});
	}

	ngAfterViewInit(): void {
		if (this.datasource) {
			this.datasource.sort = this.sort;
			this.datasource.paginator = this.paginator;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {}

	ngOnDestroy(): void {
		if (this.fetching) {
			this.fetching.unsubscribe();
		}

		if(this.subscripts.length){
			this.subscripts.forEach(sub => {
				sub.unsubscribe();
			});
		}
	}

	set_salesman_pos_location_limits() {
		let limits: any = {
			locations: false,
			salespeople: false,
			salesman: false,
			pos: false,
			client: this.config.env.client,
		};

		if (this.user.issalesman) {
			limits.salesman = true;
			this.issalesman = true;
		}

		if (this.posuser) {
			limits.pos = true;
		}


		//set initial load to all user locations selected
		let locs = [];
		this.userlocations.forEach(e => {
			locs.push(e);
		});
		limits.locations = locs;
		this.selected_locations.setValue(limits.locations.map((e)=>{return e.loccode}));


		//set sources
		let source = []
		this.sources.forEach(s => {
			if(this.posuser || this.issalesman){
				if(s.value == '2' && this.posuser){
					source.push(s);	
				}
				if(s.value == '3' && this.issalesman){
					source.push(s);
				}
			}else{
				source.push(s);
			}
		});
		limits.sources = source;
		this.selected_sources.setValue(source.map((s)=>{return s.value}))


		this.limits = limits;
	}

	normalizeDate(type){
		const date = type === 'from' ? this.fromdateCtrl.value : this.todateCtrl.value;
		return `${date.getFullYear()}-${(Number(date.getMonth()) + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
	}



	loadorderdata() {
		const sources = this.selected_sources.value;

		let salespeople;
		if(this.selected_salespeople.value.includes('any')){
			salespeople = false;
		}else{
			salespeople = this.selected_salespeople.value;
		}

		let locs;
		if(this.selected_locations.value == ''){
			locs = this.limits.locations.map((e)=>{return e.loccode})
		}else{
			locs = this.selected_locations.value;
		}

		
		const data = {
			salesman: this.limits.salesman,
			pos: this.limits.pos,
			locations: locs,
			sources: sources,
			salespeople: salespeople,
			client: this.limits.client,
			start_d: this.normalizeDate('from'),
			end_d: this.normalizeDate('to'),
			keywords: '',
			user: this.user
		};

		if (this.fetching) {
			this.fetching.unsubscribe();
		}

		this.fetching = this.ordersService.getOrderEntryLog(data).subscribe((res: any) => {
			if (res.success) {
				this.buildSubtitle();
				Array.isArray(res.data) ? '' : res.data = [];
				res.data = this.canadaDateFormat(res.data);
				this.unfilteredData = res.data;
				this.filteredData = res.data;
				this.datasource = new MatTableDataSource(res.data);
				this.datasource.paginator = this.paginator;
				this.applyFilter(false, this.searchbar.value)
			}
			this.fetching = false;
		});
	}

	compareDates(compare){
		const parts = compare.split('-')
		const y = parts[0];
		const m = parts[1];
		const d = parts[2];
		let date = new Date();
		date.setFullYear(y);
		date.setMonth(Number(m-1));
		date.setDate(d);
		date.setSeconds(0);
		date.setMinutes(0);
		date.setHours(0);
		date.setMilliseconds(0);

		let from = new Date(this.fromdateCtrl.value);
		from.setSeconds(0);
		from.setMinutes(0);
		from.setHours(0);
		from.setMilliseconds(0);

		let to = new Date(this.todateCtrl.value)
		to.setSeconds(0);
		to.setMinutes(0);
		to.setHours(0);
		to.setMilliseconds(0);


		return date >= from && date <= to;
	}

	applyFilter(event, manual?) {
		let filterValue;

		if(manual !== undefined){
			filterValue = manual;
		}else{
			filterValue = (event.target as HTMLInputElement).value;
		}

		if(filterValue == ''){
			this.datasource.filter = '';
			this.datasource.data = this.unfilteredData;
			this.datasource.filteredData = this.unfilteredData;
		}else{
			
			this.datasource.filter = filterValue.trim().toLowerCase();

			let in_range = this.unfilteredData.map((e)=>{
				let proceed = true;

				if(!this.compareDates(e.orddate)){
					proceed = false
				}

				if(proceed){
					return e;
				}

			}).filter(Boolean);

			this.datasource.filteredData = in_range;
			this.datasource.data = in_range;
		}
		
		if (this.datasource.paginator) {
			this.datasource.paginator.firstPage();
		}

		this.datasource.sort = this.sort;
		this.countorders();
	}

	resetcounts(){
		this.orders_backoffice = {count: 0, total: 0}
		this.orders_pos = {count: 0, total: 0}
		this.orders_salesperson = {count: 0, total: 0}
		this.orders_web = {count: 0, total: 0}
		this.orders_total = 0;
		this.orders_total_count = 0;
	}

	countorders(){		
		this.resetcounts();

		this.datasource.filteredData.forEach(e => {	
			if(e.placedfrom == "1"){
				this.orders_backoffice.count += 1;
				this.orders_total_count += 1;
				this.orders_backoffice.total = this.financial(Number(e.total) + Number(this.orders_backoffice.total));
			}
			if(e.placedfrom == "2"){
				this.orders_pos.count += 1;
				this.orders_total_count += 1;
				this.orders_pos.total = this.financial(Number(e.total) + Number(this.orders_pos.total));
			}
			if(e.placedfrom == "3"){
				this.orders_salesperson.count += 1;
				this.orders_total_count += 1;
				this.orders_salesperson.total = this.financial(Number(e.total) + Number(this.orders_salesperson.total));	
			}
			if(e.placedfrom == "4"){
				this.orders_web.count += 1;
				this.orders_total_count += 1;
				this.orders_web.total = this.financial(Number(e.total) + Number(this.orders_web.total));
			}
			this.orders_total = this.financial(Number(e.total) + Number(this.orders_total));

		});
	}

	financial(x) {
		if (Number.isNaN(x)) {
			x = 0
		}
		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	updateTransactions(){
		this.loadorderdata();
	}

	viewOrder(orderno: any, content: any): void {
		this.ordersService.getOrder(orderno).subscribe({
			next: (order: any) => {
				this.orderdetails = order;

				// Update saved_totals with transformed totals
				if (order.totals && order.saved_totals) {
					this.orderdetails.saved_totals = this.transformTotals(order.totals, order.saved_totals);
				}

				// Open the modal
				this.modalService
					.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' })
					.result.then(
						() => {},
						() => {
							this.totalsArray = [];
						}
					);

				
			},
			error: (err) => {
				console.error('Error fetching order details:', err);
			},
		});
	}

	transformTotals(
		totals: Record < string, number > ,
		savedTotals: any
	): any[] {
		try {
			// Check if savedTotals is an array
			if (!Array.isArray(savedTotals)) {}

			// Map totals object into a key-value structure
			const totalsMap = new Map(Object.entries(totals));

			// Update saved_totals based on matching codes
			return savedTotals.map(entry => {
				const matchingKey = this.mapCodeToKey(entry.code); // Map code to corresponding totals key
				const newValue = matchingKey ? totalsMap.get(matchingKey) : undefined;

				if (newValue !== undefined) {
					return {
						...entry,
						text: newValue.toFixed(2), // Update with new value, formatted to two decimals
					};
				}
				return entry; // Return unchanged if no match
			});
		} catch (error) {

			// Return original savedTotals if an error occurs
			return Array.isArray(savedTotals) ? savedTotals : [];
		}
	}

	// Helper function to map codes to totals keys
	private mapCodeToKey(code: string): string | undefined {
		const codeKeyMap: Record < string, string > = {
			sub_total: 'subtotal',
			total: 'total',
			fees: 'fees',
			freight: 'freight',
			tax: 'tax',
			fet: 'fet',
		};
		return codeKeyMap[code] || undefined;
	}

	private setDefaultTransactionDates(): void {
		const today = new Date();
		this.fromdate = today;
		this.todate = today;
		this.fromdateCtrl.setValue(this.fromdate);
		this.todateCtrl.setValue(this.todate);
	}




	private buildhtml(){
		let html = '<table><thead><tr>';
				html += `<th>Type</th>`
				html += `<th>Source</th>`
				html += `<th>Debtorno</th>`
				html += `<th>Branchcode</th>`
				html += `<th>Debtor</th>`
				html += `<th>Order #</th>`
				html += `<th>Status</th>`
				html += `<th>Order Date</th>`
				html += `<th>Transaction #</th>`
				html += `<th>Transaction Date</th>`
				html += `<th>Units</th>`
				html += `<th>Total</th>`
				html += `<th>Location</th>`
				html += `<th>Terms</th>`
				html += `<th>Comments</th>`
				html += `<th>Entered by</th>`
				html += `<th>Taken by</th>`
				html += `<th class='text-center'>SLSM#</th>`
				html += `<th>SLSM</th>`
		html += '</tr></thead><tbody>'
		
		this.datasource.filteredData.forEach(row => {
			html += '<tr>'
			html += `<td>${row.ordertype}</td>`
			html += `<td>${row.name.toUpperCase()}</td>`
			html += `<td>${row.debtorno}</td>`
			html += `<td>${row.branchcode}</td>`
			html += `<td>${row.brname}</td>`
			html += `<td>${row.orderno}</td>`
			html += `<td>${row.statusname}</td>`
			html += `<td>${this.formatLogDate(row.date_created)}</td>`
			html += `<td>${row.transno ? row.transno : '-'}</td>`
			html += `<td>${row.inputdate ? this.formatLogDate(row.inputdate) : '-'}</td>`
			html += `<td>${row.units}</td>`
			html += `<td>${'$' + row.total}</td>`
			html += `<td>${row.fromstkloc}</td>`
			html += `<td>${row.payterms}</td>`
			html += `<td>${row.comments}</td>`
			html += `<td>${row.enteredby}</td>`
			html += `<td>${row.takenby}</td>`
			html += `<td class='text-center'>${row.salesmancode}</td>`
			html += `<td>${row.salesmanname}</td>`
			html += '</tr>'
		});

		html += '<tr><td colspan="19"></td></tr>'
		
		html += `<tr>
					<td></td>
					<td>BACKOFFICE</td>
					<td>POS</td>
					<td>SALESPERSON</td>
					<td>WEB</td>
					<td>TOTAL</td>
					<td colspan="13"></td>
				</tr>`
		html += `<tr>
					<td>Orders</td>
					<td>${this.orders_backoffice.count}</td>
					<td>${this.orders_pos.count}</td>
					<td>${this.orders_salesperson.count}</td>
					<td>${this.orders_web.count}</td>
					<td>${this.orders_total_count}</td>
					<td colspan="13"></td>
				</tr>`
		html += `<tr>
					<td>Amount</td>
					<td>${'$' + this.orders_backoffice.total}</td>
					<td>${'$' + this.orders_pos.total}</td>
					<td>${'$' + this.orders_salesperson.total}</td>
					<td>${'$' + this.orders_web.total}</td>
					<td>${'$' + this.orders_total}</td>
					<td colspan="13"></td>
				</tr>`
		html += '</tbody></table>';

		return html;
	}


	buildSubtitle(){
		const from = this.formatLogDate(this.fromdateCtrl.value).split(" ")[0];
		const to = this.formatLogDate(this.todateCtrl.value).split(" ")[0];

		const sources = this.selected_sources.value.map((sourceid)=>{
			return this.sources.filter((source)=>{
				if(source.value == sourceid){
					return source;
				}
			})[0].view.toUpperCase();
		}).join(', ');

		
		const loccount = this.selected_locations?.value.length
		
		let locations = this.selected_locations?.value.sort().join(', ');
		if(!locations.length){
			locations = this.limits.locations.map((e)=>{return e.loccode}).join(', ');
		}

		
		let users;
		if(Array.isArray(this.selected_salespeople.value)){
			if(this.selected_salespeople.value.includes('any')){
				users = `all users`;
			}else{
				users = this.selected_salespeople.value.filter(Boolean).join(', ');
			}
		}else{
			users = `all users`;
		}

		if(this.issalesman || this.posuser){
			users = this.user.userid;
		}

		let sub;
		sub = `${sources} orders between ${from} - ${to} `;
		sub +=`for ${locations} ${loccount > 1 ? 'locations': 'location'} `;
		sub +=`for ${users}`;
		

		this.subtitle = sub;
	}

	canadaDateFormat(data){
		if(this.config?.env?.client !== 'summit'){
			return data;
		}

		data.forEach(row => {
			if(row.date_created) row.date_created = this.toCanadaDateTime(row.date_created);
			if(row.inputdate) row.inputdate = this.toCanadaDateTime(row.inputdate);
		});

		return data;
	}

	private toCanadaDateTime(value: string): string {
		return this.datePipe.transform(value, 'dd/MM/yyyy HH:mm') || value;
	}

	private formatLogDate(value: string): string {
		if (!value) return value;
		if (this.config?.env?.client === 'summit') {
			return value;
		}
		return this.datePipe.transform(value, 'M/d/yyyy HH:mm') || value;
	}


	export(type) {
		if(type == 'pdf'){
			this.exportingpdf = true;
		}else{
			this.exportingxls = true;
		}

		const html = this.buildhtml();
		const encoded: string = this.globalSearchService.base64encode(html);
		const today = new Date();

		let subtitle = this.subtitle;
		if(this.searchbar?.value?.length){
			subtitle += ` [search term: ${this.searchbar.value}]`
		}

		const data = {
			content: encoded,
			filename: `order_entry_log`,
			title: `Order Entry Log`,
			subtitle: subtitle 
		}

		if(type == 'pdf'){
			this.printService.pdf(data).subscribe((result: any) => {
				this.globalSearchService.downloadPdf(result.content, data.filename);
				this.exportingpdf = false;
			});
		}else{
			this.printService.xls(data).subscribe((result: any) => {
				this.globalSearchService.downloadXls(result.content, data.filename);
				this.exportingxls = false;
			});
		}
	}

}
